import React from "react";
import {
  LastScrollCTADynamicZoneModel,
  LastScrollCTAVariants,
} from "@models/strapi-components/last-scroll-cta";
import Link from "@components/common/Link";
import Button from "@components/common/Button";
import { twMerge } from "tailwind-merge";
import { useWrapper } from "@context/wrapper";

export interface LastScrollCTAProps {
  componentData: Partial<LastScrollCTADynamicZoneModel>;
}
const variantBasedClassName = {
  [LastScrollCTAVariants.BASE]: { wrapperClassName: "" },
  [LastScrollCTAVariants.BANNER]: {
    wrapperClassName:
      "mx-8 md:mx-16 xl:mx-[183px] rounded-3xl mb-12 md:mb-[60px] xl:mb-20",
  },
};
const LastScrollCTA: React.FunctionComponent<LastScrollCTAProps> = ({
  componentData,
}) => {
  const {
    innerHtml = <></>,
    ctaLink = "",
    ctaText = "",
    variant = LastScrollCTAVariants.BASE,
  } = componentData;

  const { wrapperClassName } = variantBasedClassName?.[variant ?? ""] ?? {};

  const isCtaLinkToTop = ctaLink === "#";

  const { wrapperRef } = useWrapper();

  const isBothCtaLinkAndTextAbsent = !ctaLink && !ctaText;

  return (
    <div
      className={twMerge(
        "flex flex-col items-center py-10 xl:py-20 bg-last-scroll bg-cover shrink-0 px-4",
        wrapperClassName
      )}
    >
      <div
        className={`!text-base md:text-inherit px-8 md:max-w-[640px] lg:max-w-[750px] [&>div>span]:!text-2xl [&>div>span]:md:!text-4xl last-scorll-inner-html`}
        dangerouslySetInnerHTML={{
          __html: innerHtml,
        }}
      />
      {!isBothCtaLinkAndTextAbsent && (
        <Button
          className="mt-8 xl:mt-12"
          variant="primaryReversed"
          style={{ padding: 0, minHeight: "43px" }}
          onClick={() => {
            if (!isCtaLinkToTop) {
              return;
            }

            wrapperRef?.current?.scroll({ top: 0, behavior: "smooth" });
          }}
        >
          {!isCtaLinkToTop ? (
            <Link
              href={ctaLink}
              linkText={ctaText}
              wrapperClassName="text-white"
              className="text-white no-underline hover:font-normal px-10 flex items-center justify-center"
              style={{ height: "43px" }}
            />
          ) : (
            <span className="text-white no-underline hover:font-normal px-10 flex items-center justify-center">
              {ctaText}
            </span>
          )}
        </Button>
      )}
    </div>
  );
};

export default LastScrollCTA;
